import {UcoastEl} from "@/scripts/core/UcoastEl";
import {getAttributeOrThrow, qsRequired} from "@/scripts/core/global";
export class ShareButtons extends UcoastEl {
    static htmlSelector = 'share-buttons'
    postTitle: string
    postUrl: string
    twitterButton: HTMLButtonElement
    emailButton: HTMLButtonElement
    copyButton: HTMLButtonElement
    success: HTMLElement

    constructor() {
        super()
        this.postTitle = encodeURIComponent(getAttributeOrThrow('data-post-title', this))
        this.postUrl = encodeURIComponent(location.href)
        this.twitterButton = qsRequired('[data-twitter-button]', this)
        this.emailButton = qsRequired('[data-email-button]', this)
        this.copyButton = qsRequired('[data-copy-button]', this)
        this.twitterButton.addEventListener('click', this.shareTwitter.bind(this))
        this.emailButton.addEventListener('click', this.shareEmail.bind(this))
        this.copyButton.addEventListener('click', this.copyLink.bind(this))
        this.success = qsRequired('[data-success]', this)
    }

    shareTwitter() {
        console.log('yeah')
        window.open(`http://twitter.com/share?url=${this.postUrl}&text=${this.postTitle}`, 'Twitter Sharer', 'toolbar=0,status=0,width=630,height=630');
        return false;
    }
    shareEmail() {
        window.open(`mailto:?subject=${this.postTitle}&body=${this.postUrl}`);
        return false;
    }
    copyLink() {
        navigator.clipboard.writeText(location.href);
        this.success.classList.add('active')
        window.setTimeout(() => {
            this.success.classList.remove('active')
        }, 2000);
    }
}
